
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 46 46","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32.32 40.87a12.41 12.41 0 01-4.464-2.243 8.316 8.316 0 01-2.186-2.734 7.068 7.068 0 01-.773-3.272v-7.423c-.009-.46.181-.901.521-1.21a1.68 1.68 0 011.13-.438A9.119 9.119 0 0031.91 21.9a1.11 1.11 0 01.954-.464c.415.005.812.172 1.108.464.42.335.874.614 1.369.826a9.567 9.567 0 003.992.821c.852 0 1.453.857 1.647 1.652v7.423a7.427 7.427 0 01-1.188 3.89c-1.272 2.01-3.435 3.471-6.443 4.354a.595.595 0 01-.397.093c-.212 0-.424-.03-.631-.088zm3.127-7.37l-.247-2.222 1.483-1.73-2.225-.248-.99-2.221-.984 2.221-2.473.247 1.731 1.727-.495 2.221 2.222-.989 1.978.994zm-9.026 7.361h-3.94v-.004H8.347a3.968 3.968 0 01-2.91-1.312 4.506 4.506 0 01-1.201-3.025V8.673a4.442 4.442 0 011.201-3.109 3.994 3.994 0 012.91-1.223h9.587a3.736 3.736 0 011.656.428c.482.243.923.561 1.312.94l2.967 3.653c.314.428.777.72 1.299.826H38.3a2.58 2.58 0 012.587 2.57v9.017a12.043 12.043 0 01-4.566-1.14 7.312 7.312 0 01-1.558-.97 2.045 2.045 0 00-1.431-.601 1.423 1.423 0 00-1.228.6 11.782 11.782 0 01-6.92 2.129 2.109 2.109 0 00-2.128 2.128v9.583a8.036 8.036 0 00.318 2.429 10.431 10.431 0 003.051 4.932l-.004-.004zM6.805 19.346v.173c0 .52.42.94.94.94h8.395c.517 0 .941-.42.941-.94v-.173c0-.52-.42-.94-.94-.94H7.75c-.517 0-.94.42-.945.94zm0-4.623v.172c0 .517.42.94.94.94h14.569c.521 0 .94-.419.94-.94v-.172c0-.521-.419-.94-.94-.94H7.75c-.521 0-.94.419-.945.94z","fill":"currentColor"}})])
          )
        }
      }
    